import { render, staticRenderFns } from "./TokenDetail.pc.vue?vue&type=template&id=af7062ba&scoped=true"
import script from "./TokenDetail.pc.vue?vue&type=script&lang=js"
export * from "./TokenDetail.pc.vue?vue&type=script&lang=js"
import style0 from "./TokenDetail.pc.vue?vue&type=style&index=0&id=af7062ba&prod&lang=scss&scoped=true"
import style1 from "./TokenDetail.pc.vue?vue&type=style&index=1&id=af7062ba&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "af7062ba",
  null
  
)

export default component.exports